import React from 'react';
import { TabSnapshot } from '../../services/storeAPI';

/**
 * Surfaces the attached customer's open tab at POS (Phase 4): current balance,
 * limit, and available room — so the cashier sees it BEFORE charging — plus the
 * pay-down and charge-to-tab actions. Renders nothing when there's no tab.
 */
interface Props {
  tab: TabSnapshot | null | undefined;
  cartRemaining: number;
  onPayDown: () => void;
  onChargeToTab: () => void;
}

export const TabBanner: React.FC<Props> = ({ tab, cartRemaining, onPayDown, onChargeToTab }) => {
  if (!tab) return null;
  const balance = parseFloat(tab.balance);
  const limit = tab.limit !== null ? parseFloat(tab.limit) : null;
  const available = tab.available !== null ? parseFloat(tab.available) : null;

  return (
    <div
      data-testid="tab-banner"
      style={{
        marginTop: 6, padding: '6px 10px', borderRadius: 6,
        background: '#FEF3C7', border: '1px solid #D97706', color: '#92400E',
        display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between', gap: 8,
      }}
    >
      <span style={{ fontSize: 13 }}>
        <strong>Open tab:</strong> ${balance.toFixed(2)}
        {limit !== null && <> of ${limit.toFixed(2)} limit</>}
        {available !== null && <> — <strong>${available.toFixed(2)} room</strong></>}
        {tab.is_default_limit && <span style={{ opacity: 0.8 }}> (default limit)</span>}
      </span>
      <span style={{ display: 'flex', gap: 6 }}>
        {balance > 0 && (
          <button onClick={onPayDown}
            style={{ fontSize: 12, padding: '2px 8px', borderRadius: 4, border: '1px solid #92400E', background: '#fff', color: '#92400E', cursor: 'pointer' }}>
            Pay down tab
          </button>
        )}
        {cartRemaining > 0 && (
          <button onClick={onChargeToTab}
            style={{ fontSize: 12, padding: '2px 8px', borderRadius: 4, border: 'none', background: '#92400E', color: '#fff', cursor: 'pointer' }}>
            Charge to tab
          </button>
        )}
      </span>
    </div>
  );
};
